
class EssAssessment {

    getOverAllAssessment(essSymptomsList) {
        //Returns object with highest essRisklevel
        return this.sortListByRiskLevel(essSymptomsList)[0] || null;
    }

    sortListByRiskLevel(listOfAssessments) {
        return _.orderBy(listOfAssessments, v => v.essRisklevel);
    }
}

const essAssessment = new EssAssessment();
export default essAssessment;


// WEBPACK FOOTER //
// ./retts/Assessment/essAssessment.js